// base
import { createSlice } from '@reduxjs/toolkit';
import { PROTECTION_SLICE_NAME } from '../actions/protection.action';

// thunks
import {
  createProtection,
  deleteProtection,
  getLastProtections,
  getProtections
} from '../thunks/protection.thunk';
import { ILastProtection, IProtection, ReqCreateProtection } from '../model/protection.model';
import { TotalMapProps } from 'modules/common';

export interface ProtectionState {
  protections: IProtection[];
  lastProtections: ILastProtection[];
  totalMap: TotalMapProps;
  createProtectionRequest: ReqCreateProtection;
}

// initialState
const initialState: ProtectionState = {
  protections: [],
  lastProtections: [],
  totalMap: {
    totalElements: 0,
    totalPages: 0
  },
  createProtectionRequest: {
    userId: '',
    workerId: '',
    equpimentList: []
  }
};

// createSlice
const protectionSlice = createSlice({
  name: PROTECTION_SLICE_NAME,
  initialState,
  reducers: {
    changeCreateProtectionRequest: (state, action) => {
      state.createProtectionRequest = {
        ...state.createProtectionRequest,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProtection.fulfilled, (state, action) => {})

      .addCase(getProtections.fulfilled, (state, action) => {
        const response = action.payload;

        state.protections = response.resultList.sort((a, b) => {
          return new Date(a.lastModifiedDate).getTime() - new Date(b.lastModifiedDate).getTime();
        });
        // state.totalMap = response.totalMap;
      })

      .addCase(getLastProtections.fulfilled, (state, action) => {
        state.lastProtections = action.payload.resultList;
      })

      .addCase(deleteProtection.fulfilled, (state, action) => {});
  }
});

export const protection = protectionSlice.name;
export const protectionReducer = protectionSlice.reducer;
export const protectionActions = protectionSlice.actions;
export const { changeCreateProtectionRequest } = protectionSlice.actions;
export default protectionSlice.reducer;
